import { get } from 'services/api';

export const SET_CUSTOM_EVENT_LIMIT_URL = '/admin/setCustomEventsFieldsLimit';
export const PROJECT_URL = '/settings/projects/esFieldLimits';

export const updateEventLimit = (projectId: number, limit: number) =>
  get(`${SET_CUSTOM_EVENT_LIMIT_URL}?projectId=${projectId}&newLimit=${limit}`);

export const fetchProjectLimitData = (projectId: number) => get(`${PROJECT_URL}/${projectId}`);
